export const CORE_DICTIONARY_EN = {
  'core-ng': {
    createSpaceModal: {
      title: 'Get going with your Workspace!',
      submitButton: 'Create Workspace',
      workspaceName: {
        label: 'What do you want to call your Workspace?',
        placeholder: 'E.g. Strategy 2050'
      },
      workspaceDescription: {
        label: 'What is your Workspace about?',
        placeholder: 'Add a description…'
      },
      fieldConfigurationScheme: 'Field Configuration Scheme',
      permissionScheme: 'Permission Scheme',
      createSpaceInfo: 'Use Workspaces to structure your Organization and the content within.',
      infoLinkText: 'Want to know more?',
      infoLinkTooltip: 'Open Knowledge Base',
      error: {
        toast: 'Error creating new Workspace!',
        required: 'This field is required',
        workspaceNameRequired: 'You need to give your Workspace a name!'
      },
      successToast: 'New Workspace has been successfully created.'
    },
    trialBanner: {
      startPharse: 'Remaining trial:',
      day: 'day. ',
      days: 'days. ',
      endPhrase: {
        regularUser: 'Talk to a Billing Administrator if you want to keep using the tool after the trial has run out!',
        admin: 'Click on this banner to go to the settings and add your payment details!'
      }
    },
    errors: {
      invalidSpace: 'The requested Workspace could not be accessed or found. You were redirected to an existing Workspace.'
    },
    permission: {
      toasts: {
        denied: 'You don’t have permission to perform this action.'
      }
    }
  }
};
